import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { OrderHeaderURLs } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'

interface ModalDeleteBuyOrderAccountProps extends ModalDeleteBuyOrderAccountLogicProps {}

const ModalDeleteBuyOrderAccount: React.FC<ModalDeleteBuyOrderAccountProps> = ({ setOpened, allRowData, ...logic }) => {
    const { t, tVars } = useTwinTranslation()
    const { deleteAccount } = useModalDeleteBuyOrderAccountLogic({ setOpened, allRowData, ...logic })

    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={deleteAccount} translations={{
            title: tVars('sureDeleteChapterName', '¿Seguro que quieres eliminar el capítulo {{accountName}}?', { accountName: allRowData?.name || '' }),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo'),
            buttonAccept: t('delete', 'Eliminar'),
            buttonCancel: t('cancel', 'Cancelar')
        }} />
    )
}

interface ModalDeleteBuyOrderAccountLogicProps extends ModalEditComponentProps {
    getCompleteData: () => void
    orderHeaderURLs: OrderHeaderURLs
}

const useModalDeleteBuyOrderAccountLogic = ({ getCompleteData, orderHeaderURLs, allRowData, setOpened }: ModalDeleteBuyOrderAccountLogicProps) => {
    const deleteAccount = useCallback(async () => {
        await twinFetchPostJSON(orderHeaderURLs.deleteAccount, {
            id: allRowData?.id,
            OrderId: allRowData?.OrderId
        })
        getCompleteData()
        setOpened(null)
    }, [orderHeaderURLs, allRowData, setOpened, getCompleteData])
    return { deleteAccount }
}

export default ModalDeleteBuyOrderAccount